import { useState, useMemo, useRef, useEffect } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import ClearIconML from '@/components/ClearIconML/index';
import { OPT_DETAIL } from '@/constants.js';
import { TextFieldCom, UploadImageCom } from '@/components/FormType';
import ImagePreviewDialog from '@/components/ImagePreviewDialog';
import request from '@/utils/request';
import HeadlineML from '../HeadlineML';
import Styled from './styles';

//当前视口宽度
const clientWidth = document.body.clientWidth;
const clientHeight = document.body.clientHeight;
// 1. 先定义统一的数组项默认值（便于复用）
const createObj = {
  id: '', // 用时间戳生成唯一id，避免重复
  prizeIndex: '',
  prizePicUrl: '',
  prizeTitle: '',
};

const arr = Array(12)
  .fill(0)
  .map((item, index) => ({
    ...createObj,
    prizeIndex: index + 1,
  }));

export default ({
  id,
  saveData,
  defaultValuesData,
  queryType,
  handleExitClick,
  handleSubmitSuccessStyle,
  handleSubmitFailStyle,
  isNext,
  setIsNext,
  step,
  status,
  saveRef,
}) => {
  const submitRef = useRef();
  const { control, setValue, errors, getValues, handleSubmit, reset, watch } =
    useForm({
      defaultValues: {
        prizePositions: arr,
      },
    });
  const { fields } = useFieldArray({
    control: control,
    name: 'prizePositions',
  });
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewUrl, setPreviewUrl] = useState();
  const [isClick, setIsClick] = useState(false);
  const [isSumit, setIsSumit] = useState(false);
  const [dialogContent, setDialogContent] = useState({
    openDialog: false,
    content: '',
  });

  useEffect(() => {
    if (defaultValuesData) {
      let prizePositions = defaultValuesData.prizePositions;
      const length = 12 - prizePositions.length;
      const resArr = Array(length)
        .fill(0)
        .map((item, index) => ({ ...createObj, prizeIndex: index + 1 }));
      prizePositions = prizePositions.concat(resArr);
      reset({ ...defaultValuesData, prizePositions });
      // reset(defaultValuesData);
    }
  }, [defaultValuesData, reset]);
  useEffect(() => {
    if (saveData?.prizeModel) {
      let prizePositions = saveData.prizePositions || [];
      const { prizeModel, noPrizeTitle } = saveData;
      let titles = [];
      const prizeModelTitles = prizeModel.map((i) => i.title);
      if (noPrizeTitle) {
        titles = prizeModelTitles.concat(noPrizeTitle);
      }
      prizePositions = [...prizePositions].map((i) => ({
        ...i,
        prizeTitle: titles.includes(i.prizeTitle) ? i.prizeTitle : '',
      }));
      const length = 12 - prizePositions.length;
      const resArr = Array(length)
        .fill(0)
        .map((item, index) => ({
          ...createObj,
          prizeIndex: prizePositions.length + index + 1,
        }));
      prizePositions = prizePositions.concat(resArr);
      prizePositions.forEach((item, index) => {
        setValue(`prizePositions.${index}.prizeIndex`, item.prizeIndex);
        setValue(`prizePositions.${index}.prizeTitle`, item.prizeTitle);
      });
    }
  }, [saveData, reset]);
  //当前视口高度
  const handlePreviewClose = () => {
    setPreviewUrl();
    setPreviewOpen(false);
  };
  //点击图片预览
  const handlePreview = (imgUrl) => {
    setPreviewUrl(imgUrl);
    setPreviewOpen(true);
  };

  const chooseList = useMemo(() => {
    if (!saveData) {
      return [];
    }
    const { prizeModel, noPrizeTitle } = saveData;
    const list = prizeModel?.map((item) => item.title) || [];
    return noPrizeTitle ? list.concat(noPrizeTitle) : list;
  }, [saveData]);

  useEffect(() => {
    // 当 isNext 变为 true 时执行点击
    if (isNext && submitRef.current && step === 3 && isClick) {
      submitRef.current.click();
      setIsClick(false);
    }
  }, [isNext, step, isClick]);
  const handleClickSave = async () => {
    if (isSumit) {
      return;
    }
    setIsSumit(true);
    const prizePositions = watch('prizePositions');
    const { noPrizeTitle, prizeModel, type } = saveData;
    if (!prizePositions.find((i) => i.prizeTitle === noPrizeTitle)) {
      setIsSumit(false);
      return window.message.toast({
        type: 'error',
        message: '请在奖品展示设置中添加无奖品后保存',
        title: '',
      });
    }
    if (prizePositions && prizePositions.length > 0) {
      const modelTitles = prizeModel.map((i) => i.title);
      const positionTitles = prizePositions
        .filter((i) => i)
        .map((i) => i.prizeTitle);
      const positionTitleSet = new Set(positionTitles);

      const isHasUnSelectedPrize = modelTitles.some(
        (item) => !positionTitleSet.has(item),
      );

      if (isHasUnSelectedPrize && type !== 'SCRATCH_CARD') {
        setIsSumit(false);
        setDialogContent({
          openDialog: true,
          content:
            '有奖品未在奖品展示设置中被选择，未被选择的奖品将不会被抽中，确定仍要保存该活动吗？',
        });
        return;
      }
    }

    if (id) {
      const prizeNumList = prizeModel?.map((item) => ({
        prizeId: item.prizeId,
        quantity: item.quantity,
      }));
      const res = await request('/activityLottery/checkPrizeNum', {
        method: 'POST',
        data: {
          prizeNumList,
          id,
        },
      });
      if (res?.data?.length > 0) {
        const mes = res.data.reduce((accumulator, currentValue) => {
          return (
            accumulator +
            `${currentValue.prizeName}奖品的数量小于中奖次数${currentValue.quantity}`
          );
        }, '');
        setIsSumit(false);
        return window.message.toast({
          type: 'error',
          message: mes,
          title: '保存失败',
        });
      }
    }
    setIsSumit(false);
    setIsNext(true);
    setIsClick(true);
  };

  const handleSure = () => {
    setDialogContent({
      openDialog: false,
    });
    setIsNext(true);
    setIsClick(true);
  };
  return (
    <Styled>
      <form
        onSubmit={handleSubmit(handleSubmitSuccessStyle, handleSubmitFailStyle)}
      >
        <div className="from-content">
          <div className="left-content">
            <HeadlineML title="基础样式" />
            <Box>
              <Controller
                render={(pr) => (
                  <UploadImageCom
                    uW="200"
                    uH="200"
                    iW="200"
                    iH="200"
                    pr={pr}
                    label={
                      <>
                        <span>转盘图片设定</span>
                        <span style={{ marginLeft: '8px', color: '#999999' }}>
                          建议尺寸1520*416，大小不超过2M
                        </span>
                      </>
                    }
                    disabled={status === '1' || queryType === OPT_DETAIL}
                    getValues={getValues}
                    fileSize={2 * 1024 * 1024}
                    acceptType={['png', 'jpg', 'jpeg', 'webp', 'gif']}
                    maxNumber="1"
                    handlePreview={handlePreview}
                    defaultValues={
                      getValues('backgroundPicUrl')
                        ? [getValues('backgroundPicUrl')]
                        : []
                    }
                    bucket="PRIZE-SETTING-FILE"
                    required={true}
                  />
                )}
                name="backgroundPicUrl"
                control={control}
                rules={{
                  required: true,
                }}
              />
              <div className="img-limit-style">
                格式为格式为png/jpg/jpeg/webp/gif
              </div>
              <FormHelperText error={Boolean(errors.backgroundPicUrl)}>
                {errors.backgroundPicUrl && '请选择图片'}
              </FormHelperText>
            </Box>
            <Box>
              <Controller
                render={(pr) => (
                  <UploadImageCom
                    uW="200"
                    uH="200"
                    iW="200"
                    iH="200"
                    pr={pr}
                    label={
                      <>
                        <span>开始按钮图片</span>
                        <span style={{ marginLeft: '8px', color: '#999999' }}>
                          建议尺寸1520*416，大小不超过2M
                        </span>
                      </>
                    }
                    disabled={status === '1' || queryType === OPT_DETAIL}
                    getValues={getValues}
                    fileSize={2 * 1024 * 1024}
                    acceptType={['png', 'jpg', 'jpeg', 'webp', 'gif']}
                    maxNumber="1"
                    handlePreview={handlePreview}
                    defaultValues={
                      getValues('startBtnPicUrl')
                        ? [getValues('startBtnPicUrl')]
                        : []
                    }
                    bucket="PRIZE-SETTING-FILE"
                    required={true}
                  />
                )}
                name="startBtnPicUrl"
                control={control}
                rules={{
                  required: true,
                }}
              />
              <div className="img-limit-style">格式为png/jpg/jpeg/webp/gif</div>
              <FormHelperText error={Boolean(errors.startBtnPicUrl)}>
                {errors.startBtnPicUrl && '请选择图片'}
              </FormHelperText>
            </Box>
          </div>
          <div className="middle-content"></div>
          <div className="center-content">
            <HeadlineML
              title="奖品展示设置"
              subTitle="此数配置奖品的展示顺序，建议选择偶数个奖品"
            />
            <div className="prize-table-wrap">
              <div className="prize-table-head">
                <div className="th th-1">位置编号</div>
                <div className="th th-2">奖品设置</div>
              </div>
              {fields.map((item, index) => {
                return (
                  <div className="prize-table-body" key={index}>
                    <div className="td td-1">{index + 1}</div>
                    <div className="td td-2">
                      <Controller
                        control={control}
                        name={`prizePositions.${index}.prizeIndex`}
                        value={index + 1}
                        as={<input hidden />}
                      />
                      <Controller
                        control={control}
                        name={`prizePositions.${index}.id`}
                        as={<input hidden />}
                      />
                      <Controller
                        control={control}
                        name={`prizePositions.${index}.prizeTitle`}
                        render={({ value, onChange }) => {
                          return (
                            <FormControl
                              variant="standard"
                              sx={{ width: '100%' }}
                            >
                              <InputLabel htmlFor="age-native-simple">
                                选择奖项
                              </InputLabel>
                              <Select
                                disabled={
                                  status === '1' || queryType === OPT_DETAIL
                                }
                                displayEmpty
                                value={value || ''}
                                onChange={onChange}
                                inputProps={{
                                  name: 'age',
                                  id: 'age-native-simple',
                                }}
                              >
                                {(chooseList || []).map((m, n) => (
                                  <MenuItem value={m} key={n}>
                                    {m}
                                  </MenuItem>
                                ))}
                              </Select>
                              <ClearIconML
                                handleClick={() => {
                                  onChange('');
                                }}
                                clearValue={
                                  status !== '1' &&
                                  queryType !== OPT_DETAIL &&
                                  value
                                }
                              ></ClearIconML>
                            </FormControl>
                          );
                        }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="middle-content"></div>
          <div className="right-content">
            <HeadlineML title="分享样式" />
            <TextFieldCom
              control={control}
              label="小程序卡片标题"
              name="miniTitle"
              getValues={getValues}
              setValue={setValue}
              errors={errors}
              initErrorText="不超过30个字"
              disabled={status === '1' || queryType === OPT_DETAIL}
              rules={{
                maxLength: 30,
              }}
            />
            <TextFieldCom
              control={control}
              label="PagePath"
              name="pagePath"
              getValues={getValues}
              setValue={setValue}
              errors={errors}
              initErrorText="不超过200个字"
              disabled={status === '1' || queryType === OPT_DETAIL}
              rules={{
                maxLength: 200,
              }}
            />
            <Box>
              <Controller
                render={(pr) => (
                  <UploadImageCom
                    uW="260"
                    uH="208"
                    iW="260"
                    iH="208"
                    pr={pr}
                    label={
                      <>
                        <span>小程序封面</span>
                        <div
                          style={{
                            color: '#999999',
                            fontSize: '12px',
                            marginTop: '8px',
                          }}
                        >
                          小程序封面比例为封面尺寸：520x416，图片文件大小不超过2M
                        </div>
                      </>
                    }
                    disabled={status === '1' || queryType === OPT_DETAIL}
                    getValues={getValues}
                    fileSize={2 * 1024 * 1024}
                    acceptType={['png', 'jpg', 'jpeg', 'webp', 'gif']}
                    maxNumber="1"
                    handlePreview={handlePreview}
                    defaultValues={
                      getValues('thumbUrl') ? [getValues('thumbUrl')] : []
                    }
                    bucket="PRIZE-SETTING-FILE"
                  />
                )}
                name="thumbUrl"
                control={control}
              />
              <div className="img-limit-style">
                点击保存后您上传内容将会保存在微信公众号素材中心，请勿在公众号素材中心删除上传的文件。
              </div>
            </Box>
          </div>
        </div>
        <div className="from-button-wrap">
          <Button
            color="secondary"
            variant="contained"
            className="goFront"
            type="submit"
            sx={{ width: '96px' }}
          >
            上一页
          </Button>
          {queryType !== OPT_DETAIL && (
            <Button
              variant="contained"
              className="goFront"
              ref={saveRef}
              onClick={handleClickSave}
            >
              完成
            </Button>
          )}
          <button ref={submitRef} type="submit" hidden></button>
          <div
            style={{
              height: '40px',
              width: '1px',
              backgroundColor: '#E5E5E5',
            }}
          ></div>
          <Button
            color="secondary"
            variant="contained"
            className="exit"
            onClick={handleExitClick}
            startIcon={<CloseIcon sx={{ width: '20px', height: '20px' }} />}
          >
            退出
          </Button>
        </div>
      </form>
      <ImagePreviewDialog onClose={handlePreviewClose} visible={previewOpen}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            alt=""
            src={previewUrl}
            style={{
              maxWidth: `${clientWidth * 0.6}px`,
              maxHeight: `${clientHeight * 0.6}px`,
              margin: 'auto',
            }}
          />
        </div>
      </ImagePreviewDialog>
      <Dialog
        open={dialogContent.openDialog}
        onClose={() => {
          setDialogContent({
            openDialog: false,
          });
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ minWidth: '200px' }}
          >
            {dialogContent?.content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="text"
            sx={{ color: '#999', width: '57px' }}
            onClick={() => {
              setDialogContent({
                openDialog: false,
              });
            }}
          >
            取消
          </Button>
          <Button
            variant="text"
            sx={{ width: '57px' }}
            onClick={handleSure}
            autoFocus
          >
            确定
          </Button>
        </DialogActions>
      </Dialog>
    </Styled>
  );
};
